import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import { getSampleDraftTreeData, updateBatch, create, deleteRecord } from './../../service';
import { postRecordList } from './../../../filterTree/service';
import { debounce } from 'lodash';
import { AssetModuleTable } from '@/asset/AssetModuleTable';
import { Api as FetchAPI } from '@cui/req';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Table, Empty, Tabs, message, Input } from 'antd';

interface PicProductTableProps {
  currentSelectNode: any;
  pageType: string;
}

const PicProductTable: ForwardRefExoticComponent<PropsWithoutRef<PicProductTableProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    currentSelectNode,
    pageType,
  },
  ref,
) => {
  const picTableRef = useRef<any>();
  const [mode, setMode] = useState<string>('view');
  const [valueLength, setValueLength] = useState<number>(0);

  const addPic = async () => {
    const data = {
      cpart_number: currentSelectNode?.cpartCode,
    };
    const res = await create({
      appId: 'master_data',
      modelId: 'md_cpart_pictures',
      data,
    });
    const id = res.data.lastId;
    if (res.success && id) {
      picTableRef.current?.addEditRecord({
        md_cpart_pictures_id: id,
        ...data,
      });
    }
  };

  const deletePic = async (recordData: any) => {
    await onMaterialSave();
    const res = await deleteRecord({
      appId: 'master_data',
      modelId: 'md_cpart_pictures',
      recordId: recordData?.md_cpart_pictures_id,
    });
    if (res.success) {
      picTableRef.current?.reload();
    }
  };

  const onMaterialSave = async () => {
    if (!currentSelectNode || mode === 'view') return;
    console.log('onMaterialSave-pic-product');
    const picList = picTableRef.current?.getRowsData();
    const picMateList = picList?.map((el: any) => {
      return {
        recordId: el.md_cpart_pictures_id || '0',
        values: {
          cpart_number: el.cpart_number || null,
          conments: el.conments || null,
          oss_path: el.oss_path || null,
          md_cpart_pictures_id: el.md_cpart_pictures_id || null,
        },
      };
    });
    const picUpdateList = picMateList?.filter((el: any) => el.recordId !== '0');
    const params = {
      appId: 'master_data',
      modelId: 'md_cpart_pictures',
      data: picUpdateList?.map((el: any) => el.values) || [],
    };
    const res = await updateBatch(params);
  };
  useMemo(() => {
    let newMode = 'view';
    if (currentSelectNode?.isProduct && pageType !== 'view') {
      newMode = 'edit';
    }
    setMode(newMode);
  }, [currentSelectNode]);

  return (
    <AssetModuleTable
      API={{ FetchAPI }}
      moduleID={'md_cpart_pictures'}
      namespaceID="master_data"
      columns={[
        { dataIndex: 'oss_path' },
        { dataIndex: 'conments' },
      ]}
      search={false}
      tableBaseMode={mode}
      hidePagination={pageType !== 'view' ? true : undefined}
      headerTitle={'none'}
      requestParams={{
        filter: `(cpart_number = '${currentSelectNode?.cpartCode}')`,
        sort: 'created_at',
        incPageNavigation: true,
        incTotal: true,
        limit: 1000,
        page: 1,
        pageCursor: '',
        version: '0',
      }}
      ref={picTableRef}
      rowDelable={false}
      optionColumns={mode !== 'view' ? {
        title: '操作',
        valueType: 'option',
        dataIndex: 'options',
        fixed: 'right',
        width: 140,
        align: 'center',
        render: (_text: any, record: any, index: number) => (
          <span>
            <Button
              type="link"
              onClick={() => {
                deletePic(record);
              }}
            >
              删除
            </Button>
          </span>
        ),
      } : false}
      toolBarRender={mode === 'edit' && currentSelectNode ? [
        <>
          <Button type="primary" ghost onClick={addPic}>
            <PlusOutlined /> 新建
          </Button>
        </>,
      ] : undefined}
      onChange={(values: any) => {
        if (values.length === 0) return;
        if (values.length !== valueLength) {
          setValueLength(values.length);
        } else {
          debounce(onMaterialSave, 1000)();
        }
      }}
    />
  );
});

export default PicProductTable;
